import { initializeApp } from "@firebase/app";
import { getMessaging, isSupported } from "@firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyAfPF-o3CKpaCgCHWglpnfh8964PPcxK9M",
  authDomain: "zayadryfruits-android.firebaseapp.com",
  projectId: "zayadryfruits-android",
  storageBucket: "zayadryfruits-android.firebasestorage.app",
  messagingSenderId: "420713026845",
  appId: "1:420713026845:web:771cd8c67c79ee9ebf3df4",
  measurementId: "G-QYPPZHHGWW"
};

let messaging = null;

try {
  const app = initializeApp(firebaseConfig);

  // isSupported() probes IndexedDB/serviceWorker availability at module
  // load time, on every page — in a browser context that denies storage
  // outright (see utils/safeStorage.js), that probe can reject instead of
  // resolving false. This runs before any component mounts, so an
  // unhandled rejection here isn't caught by the app's ErrorBoundary.
  isSupported()
    .then((supported) => {
      if (supported) {
        messaging = getMessaging(app);
      }
    })
    .catch(() => {});
} catch (e) {
  // Push notifications are optional; the rest of the app must not depend
  // on Firebase having initialized successfully.
}

export { messaging };